import React from 'react'
import Title from '@/components/Title'
import style from './style/family.module.scss'

const ImageModal = ({ src = '', title = '' }: { src: string, title?: string }): React.ReactElement => {
  return (
    <div>
      {title !== '' ? <Title type='h4'>{title}</Title> : null}
      <img src={src} className={style.modal__img} />
    </div>
  )
}

export default ImageModal
